import React from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Menu from "./components/Menu";
import HomeView from "./components/HomeView";
import FloorsView from "./components/FloorsView";
import TFloorsView from "./components/TFloorsView";

function Layout({ children }) {
  const location = useLocation();

  const hideMenu = location.pathname.endsWith("/floors");

  return (
    <>
      {!hideMenu && <Menu />}
      <div>{children}</div>
    </>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Layout>
              <HomeView />
            </Layout>
          }
        />
        <Route
          path="/hotel/:hotelId/:apiKey/:hotelName/tfloors"
          element={
            <Layout>
              <TFloorsView />
            </Layout>
          }
        />
        <Route
          path="/hotel/:hotelId/:apiKey/:hotelName/floors"
          element={
            <Layout>
              <FloorsView />
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
